"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const LockOutlined_1 = __importDefault(require("@material-ui/icons/LockOutlined"));
const Visibility_1 = __importDefault(require("@material-ui/icons/Visibility"));
const VisibilityOff_1 = __importDefault(require("@material-ui/icons/VisibilityOff"));
const classnames_1 = __importDefault(require("classnames"));
const react_1 = require("react");
const components_1 = require("components");
const utils_1 = require("utils");
function InputSSN({ input, meta, placeholder = 'Social Security Number / ITIN', label = 'Social Security Number', altClass = null, required = false, requiredIndicator = ' *', tooltip = null, labelNote = null, formChange, }) {
    const [rawSSN, setRawSSN] = (0, react_1.useState)('');
    const [displayValue, setDisplayValue] = (0, react_1.useState)('');
    const [isCensored, setIsCensored] = (0, react_1.useState)(true);
    const applyMask = (value) => {
        let maskedValue = value
            .split('')
            .map((char, index) => (index < 5 && isCensored ? 'X' : char))
            .join('');
        if (maskedValue.length > 3 && maskedValue.length < 6) {
            maskedValue = maskedValue.slice(0, 3) + '-' + maskedValue.slice(3);
        }
        else if (maskedValue.length > 5) {
            maskedValue =
                maskedValue.slice(0, 3) +
                    '-' +
                    maskedValue.slice(3, 5) +
                    '-' +
                    maskedValue.slice(5);
        }
        return maskedValue;
    };
    const handleChange = (e) => {
        if (e.target.value.length > 11) {
            return;
        }
        if (e.target.value.length <= displayValue.length) {
            let newDisplayValue = displayValue.slice(0, -1);
            if (newDisplayValue.slice(-1) === '-') {
                newDisplayValue = newDisplayValue.slice(0, -1);
            }
            setDisplayValue(newDisplayValue);
            setRawSSN(rawSSN.slice(0, -1));
        }
        else {
            const onlyNums = e.target.value.replace(/[^0-9]+/g, '');
            const lastDigit = onlyNums.slice(-1);
            if (!(0, utils_1.isNumberString)(lastDigit)) {
                return;
            }
            const newValue = rawSSN + lastDigit;
            setRawSSN(newValue);
            setDisplayValue(applyMask(newValue));
        }
    };
    (0, react_1.useEffect)(() => {
        const onlyNumbers = rawSSN.replace(/[^0-9]+/g, '');
        formChange(input.name, onlyNumbers);
    }, [rawSSN]);
    (0, react_1.useEffect)(() => {
        if (input.value) {
            setDisplayValue(applyMask(input.value));
        }
    }, [isCensored]);
    const fieldClass = (0, classnames_1.default)({
        [input.className]: input.className,
        'error-fieldset': (meta.error && meta.touched) ||
            (meta.error && meta.pristine === false && input.value !== ''),
    });
    const labelClass = (0, classnames_1.default)({
        'form-label': altClass === 'coreUI',
    });
    const inputClass = (0, classnames_1.default)({
        'form-control': altClass === 'coreUI',
    });
    return ((0, jsx_runtime_1.jsxs)("fieldset", { "data-testid": `fieldset-${input.name}`, className: fieldClass, children: [(0, jsx_runtime_1.jsxs)("span", { children: [(0, jsx_runtime_1.jsxs)(components_1.Label, { size: "medium", "data-testid": `label-${input.name}`, htmlFor: input.name, className: `${altClass ? labelClass : ''}`, children: [label, required && ((0, jsx_runtime_1.jsx)("span", { className: "required-indicator", "aria-hidden": "true", children: requiredIndicator })), tooltip ? (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: tooltip }) : null] }), labelNote && labelNote] }), (0, jsx_runtime_1.jsxs)("div", { className: "input-wrapper", children: [(0, jsx_runtime_1.jsxs)("div", { className: "flex-center", children: [(0, jsx_runtime_1.jsx)("input", { type: "tel", ...input, name: `fake-${input.name}`, onChange: handleChange, value: displayValue, placeholder: placeholder, className: `${altClass ? inputClass : ''}` }), (0, jsx_runtime_1.jsx)("input", { type: "hidden", ...input }), (0, jsx_runtime_1.jsx)("div", { className: "input-hidden-icon", children: (0, jsx_runtime_1.jsx)("button", { onClick: () => setIsCensored(!isCensored), type: "button", children: isCensored ? (0, jsx_runtime_1.jsx)(VisibilityOff_1.default, {}) : (0, jsx_runtime_1.jsx)(Visibility_1.default, {}) }) })] }), (meta.error || meta.submitError) && meta.touched && ((0, jsx_runtime_1.jsx)("span", { className: "error-message", children: meta.error || meta.submitError })), (meta.touched || meta.active) && ((0, jsx_runtime_1.jsxs)("div", { className: "ssn-tip", children: [(0, jsx_runtime_1.jsx)(LockOutlined_1.default, { className: "gray-icon" }), (0, jsx_runtime_1.jsx)(components_1.P, { children: "\u00A0We use your social security or ITIN number to validate your information and check your credit. Your information is transmitted securely." })] }))] })] }));
}
exports.default = InputSSN;
